import { isMobile } from "./is-mobile";

const isPad = isMobile.apple.tablet;

export { isPad }